import { render, staticRenderFns } from "./mod-00.vue?vue&type=template&id=54481a25&"
import script from "./mod-00.vue?vue&type=script&lang=js&"
export * from "./mod-00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports